export default __webpack_public_path__ + "static/media/Thief's Helm of the Fifth Stage.07b739d2.jpg";